var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45398 1.5641C8.60275 1.10624 9.2505 1.10624 9.39926 1.5641L10.8792 6.11884C10.9457 6.3236 11.1365 6.46224 11.3518 6.46224H16.141C16.6224 6.46224 16.8226 7.07828 16.4331 7.36125L12.5586 10.1762C12.3844 10.3028 12.3115 10.5271 12.3781 10.7319L13.858 15.2866C14.0067 15.7445 13.4827 16.1252 13.0932 15.8422L9.21873 13.0272C9.04455 12.9007 8.8087 12.9007 8.63452 13.0272L4.76002 15.8422C4.37054 16.1252 3.8465 15.7445 3.99527 15.2866L5.4752 10.7319C5.54173 10.5271 5.46884 10.3028 5.29466 10.1762L1.42016 7.36125C1.03069 7.07828 1.23085 6.46224 1.71227 6.46224H6.50142C6.71671 6.46224 6.90753 6.3236 6.97406 6.11884L8.45398 1.5641Z",
    stroke: "#EE7233",
    strokeWidth: 1.5332
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldStarIcon);
export default __webpack_public_path__ + "static/media/gold_star_icon.31c6a7df6333cabe193c941cb52eed4d.svg";
export { ForwardRef as ReactComponent };